import * as PIXI from "pixi.js";
import gsap from "gsap";
import MyApplication from "../../../pixi/MyApplication";
import AssetsManager from "../../../pixi/AssetsManager";

/**
 * TutorialViewクラス
 */
class TutorialView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //ムービークリップ
  private _yaji: PIXI.Sprite;
  private _hand: PIXI.Sprite;

  //ループ
  private _loopTimer: gsap.core.Tween;

  // ---------------------------------------------------------------------------------------------------------
  // --	TutorialView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    //矢印
    this._yaji = AssetsManager.instance.createSpriteByName("yaji.png");
    this.addChild(this._yaji);

    //手
    this._hand = AssetsManager.instance.createSpriteByName("hand.png");
    this._hand.x = 6;
    this._hand.y = 40;
    this.addChild(this._hand);

    //スケール
    this.scale.set(2);

    //リセット
    this.reset();
  }

  /**
   * リセット
   */
  reset(): void {
    //Tween停止
    gsap.killTweensOf(this._yaji);
    gsap.killTweensOf(this._hand);

    //手の初期化
    this._hand.visible = false;
    this._hand.y = 40;

    //ループ停止
    if (this._loopTimer) {
      this._loopTimer.kill();
      this._loopTimer = null;
    }

    //非表示
    this.visible = false;
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	ACTION
  // ---------------------------------------------------------------------------------------------------------

  /**
   * 表示
   */
  show(): void {
    //表示
    this.visible = true;

    //ちょっと間をおく
    gsap.delayedCall(0.5, this.animation.bind(this));
  }

  /**
   * アニメーション
   */
  animation(): void {
    //上へスワイプ
    gsap.to(this._hand, {
      duration: 10 / 60,
      delay: 0,
      y: 40 - 40,
      ease: "none",
      onStart: () => {
        this._hand.y = 40;
        this._hand.visible = true;
        gsap.delayedCall(50 / 60, () => {
          this._hand.visible = false;
        });
      },
    });

    //下へスワイプ
    gsap.to(this._hand, {
      duration: 10 / 60,
      delay: 90 / 60,
      y: 63 + 40,
      ease: "none",
      onStart: () => {
        this._hand.y = 63;
        this._hand.visible = true;
        gsap.delayedCall(50 / 60, () => {
          this._hand.visible = false;
        });
      },
    });

    //ループ
    this._loopTimer = gsap.delayedCall(180 / 60, this.animation.bind(this));
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default TutorialView;
